import { useMutation } from '@tanstack/react-query';

import { searchL3Memories } from '../api/memory.client.js';

export interface SearchMemoriesInput {
  query: string;
  limit?: number;
}

export function useMemorySearch() {
  return useMutation({
    mutationFn: async (input: SearchMemoriesInput) => searchL3Memories(input.query, input.limit ?? 10),
  });
}
